<script setup>

import { ref, computed, onMounted, watch } from "vue";
import UtilArray from "@/utils/UtilArray.mjs";
import ERP from "@apiV2/ERP.mjs";
import View from "@apiV2/View.mjs";
import TelaTabela from '@/components/v2/telas/TelaTabela/TelaTabela.vue';
import BotaoIconeBase from '@/components/v2/base/BotaoIconeBase/BotaoIconeBase.vue';
import VisualizarDadosModal from "./VisualizarDados/VisualizarDadosModal.vue";
import LiberarDadosModal from "./LiberarDados/LiberarDadosModal.vue";
import AprovarDadosModal from "./AprovarDados/AprovarDadosModal.vue";
import GerarPagamentosModal from "./GerarPagamentos/GerarPagamentosModal.vue";
import BaixarDadosModal from "./BaixarDados/BaixarDadosModal.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore();

//==================================================================//
//======================== Dados Originais =========================//
//==================================================================//

const dadosOriginais = ref([]);
const dadoOriginal = ref({});

//==================================================================//
//====================== Controles Desativados =====================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//====================== Visualizando Dado =========================//
//==================================================================//

const visualizandoDado = ref(false);

//==================================================================//
//======================= Liberando Dado ===========================//
//==================================================================//

const liberandoDado = ref(false);

//==================================================================//
//======================= Aprovando Dado ===========================//
//==================================================================//

const aprovandoDado = ref(false);

//==================================================================//
//===================== Gerando Pagamentos =========================//
//==================================================================//

const gerandoPagamentos = ref(false);

//==================================================================//
//======================== Baixando Dado ===========================//
//==================================================================//

const baixandoDado = ref(false);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update;

};

//==================================================================//
//==================== Altera Dados Originais ======================//
//==================================================================//

const alteraDadosOriginais = (update=[])=>{

    dadosOriginais.value = update;

};

//==================================================================//
//================== Altera Dado Original ==========================//
//==================================================================//

const alteraDadoOriginal = (update={})=>{

    dadoOriginal.value = update

};

//==================================================================//
//=================== Altera Visualizando Dado =====================//
//==================================================================//

const alteraVisualizandoDado = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    visualizandoDado.value = update?.modal || false;

};

//==================================================================//
//==================== Altera Liberando Dado =======================//
//==================================================================//

const alteraLiberandoDado = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    liberandoDado.value = update?.modal || false;

};

//==================================================================//
//==================== Altera Aprovando Dado =======================//
//==================================================================//

const alteraAprovandoDado = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    aprovandoDado.value = update?.modal || false;

};

//==================================================================//
//================ Altera Gerando Pagamentos =======================//
//==================================================================//

const alteraGerandoPagamentos = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    gerandoPagamentos.value = update?.modal || false;

};

//==================================================================//
//===================== Altera Baixando Dado =======================//
//==================================================================//

const alteraBaixandoDado = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    baixandoDado.value = update?.modal || false;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================ Dados ===============================//
//==================================================================//

const dados = ref([]);

//==================================================================//
//===================== Loaded Dados Originais =====================//
//==================================================================//

const loadedDadosOriginais = ref(false);

//==================================================================//
//===================== Loading Lista de Dados =====================//
//==================================================================//

const loadingListaDeDados = ref(false);

//==================================================================//
//======================== Numero Filtro ===========================//
//==================================================================//

const dadoNumeroFiltro = ref("");

//==================================================================//
//======================== Credor Filtro ===========================//
//==================================================================//

const dadoCredorFiltro = ref("");

//==================================================================//
//========================== HEADERS ================================//
//==================================================================//

const dadosHeaders = [
    { text: 'N°',                      value: 'codigo',                 type: 'string' },
    { text: 'Status',                  value: 'status',                 type: 'string' },
    { text: 'Credor',                  value: 'credorNome',             type: 'string' },
    { text: 'Valor Original',          value: 'valorOriginal',          type: 'money' },
    { text: 'Valor a Reservar',        value: 'valorParaReservar',      type: 'money' },
    { text: 'Soma dos Descontos',      value: 'valorDesconto',          type: 'money' },
    { text: 'Soma dos Pagamentos',     value: 'valorPagamento',         type: 'money' },
    { text: 'Valor Reservado',         value: 'valorReservado',         type: 'money' },
    { text: 'Valor a Liquidar',        value: 'valorParaPagar',         type: 'money' },
    { text: 'Valor Liquidado',         value: 'valorPago',              type: 'money' },
    { text: 'Valor a Vincular',        value: 'valorParaVincular',      type: 'money' },
    { text: 'Valor Vinculado',         value: 'valorVinculado',         type: 'money' },
    { text: 'Contas a Pagar',          value: 'contasAPagarQuantidade', type: 'number' },
    { text: 'Pagamentos',              value: 'pagamentosQuantidade',   type: 'number' },
];

//==================================================================//
//======================== Dados Filtrados =========================//
//==================================================================//

const dadosFiltrados = computed(()=>{

    return dados?.value?.reduce((acc,dado)=>{

        if(!dadoNumeroFiltroValido(dado?.codigo)){
            return acc;
        }

        if(!dadoCredorFiltroValido(dado?.credorNome)){
            return acc;
        }

        acc.push(dado);

        return acc;

    },[]);

});

//==================================================================//
//======================= Dado Numero Valido =======================//
//==================================================================//

const dadoNumeroFiltroValido = (dadoCodigo) =>{

    if(dadoNumeroFiltro.value === ""){
        return true;
    }

    if(dadoCodigo != dadoNumeroFiltro.value){
        return false;
    }

    return true;

};

//==================================================================//
//======================= Dado Credor Valido =======================//
//==================================================================//

const dadoCredorFiltroValido = (credorNome) =>{

    if(dadoCredorFiltro.value === ""){
        return true;
    }

    if(credorNome != dadoCredorFiltro.value){
        return false;
    }

    return true;

};

//==================================================================//
//==================== Altera Dado Numero Filtro ===================//
//==================================================================//

const alteraDadoNumeroFiltro = (dado) =>{

    dadoNumeroFiltro.value = dado?.codigo || "";

};

//==================================================================//
//==================== Altera Dado Credor Filtro ===================//
//==================================================================//

const alteraDadoCredorFiltro = (dado) =>{

    dadoCredorFiltro.value = dado?.credorNome || "";

};

//==================================================================//
//====================== FILTROS CONFIGURADOS =======================//
//==================================================================//

const filtros = computed(() => [

    { label: 'N°',      items: dados.value, itemText: 'codigo',     onChange: alteraDadoNumeroFiltro },
    { label: 'Credor',  items: dados.value, itemText: 'credorNome', onChange: alteraDadoCredorFiltro },

]);

//==================================================================//
//======================== Altera Dados ============================//
//==================================================================//

const alteraDados = (update)=>{

    dados.value = update;

};

//==================================================================//
//================== Altera Loading Lista De Dados =================//
//==================================================================//

const alteraLoadingListaDeDados = (update) => {

    alteraControlesDesativados(update);
    loadingListaDeDados.value = update;

};

//==================================================================//
//=============== Altera Loaded Dados Originais ====================//
//==================================================================//

const alteraLoadedDadosOriginais = (update) => {

    alteraControlesDesativados(!update);
    loadedDadosOriginais.value = update;

};

//==================================================================//
//==================== Load Dados Originais ========================//
//==================================================================//

const loadDadosOriginais = async () =>{

    alteraLoadedDadosOriginais(false);

    const dadosResponse = await ERP.getManyWithView(View.CONTAS_A_PAGAR);

    alteraDadosOriginais(dadosResponse.data);

    alteraLoadedDadosOriginais(true);

};

//==================================================================//
//====================== Load Preenchendo Dado =====================//
//==================================================================//

const loadListaDeDados = async () => {

    alteraLoadingListaDeDados(true);

    await loadDadosOriginais();

    alteraLoadingListaDeDados(false);

};

//===================================================================//
//========================= Prepara Dados ===========================//
//=================================================-=================//

const preparaDados = (dadosParaPreparar = [])=>{

    const dadosPreparados = dadosParaPreparar?.map((dado,index)=>{

        let contasAPagar = dado?.parcelas?.map((parcela)=>{

            let contaAPagar = parcela?.contaAPagar;

            let pagamentos = contaAPagar?.pagamentos?.map((pagamento)=>{

                return{
                    id: pagamento?.id || "",
                    sequencia: pagamento?.sequencia || "",
                    status: pagamento?.status || "",
                    notaFiscalRecebidaID: pagamento?.notaFiscalRecebida?.id || "",
                    notaFiscalRecebidaNumero: pagamento?.notaFiscalRecebida?.numero || "",
                    notaFiscalRecebidaChaveAcesso: pagamento?.notaFiscalRecebida?.chaveAcesso || "",
                    notaFiscalRecebidaPlugNotasID: pagamento?.notaFiscalRecebida?.plugNotasID || "",
                    dataCriacao: pagamento?.dataVencimentoFormatada || "",
                    dataVencimento: pagamento?.dataVencimentoFormatada || "",
                    valorDesconto: pagamento?.valorDesconto || 0,
                    valorPagamento: pagamento?.valorPagamento || 0,
                    valorReservado: pagamento?.valorReservado || 0,
                    valorParaPagar: pagamento?.valorParaPagar || 0,
                    valorPago: pagamento?.valorPago || 0,
                    valorParaVincular: pagamento?.valorParaVincular || 0,
                    valorVinculado: pagamento?.valorVinculado || 0,
                }

            });

            return{
                id: contaAPagar?.id || "",
                aberto: false,
                codigo: contaAPagar?.codigo || "",
                parcelaCodigo: parcela?.codigo || "",
                status: contaAPagar?.status || "",
                forma: contaAPagar?.pagamentoForma || "",
                tipo: contaAPagar?.pagamentoTipo || "",
                evento: contaAPagar?.pagamentoEvento || "",
                descricao: contaAPagar?.descricao || "",
                dataVencimento: contaAPagar?.dataVencimentoFormatada || "",
                valorOriginal: contaAPagar?.valorOriginal || 0,
                valorParaReservar: contaAPagar?.valorParaReservar || 0,
                valorDesconto: contaAPagar?.valorDesconto || 0,
                valorPagamento: contaAPagar?.valorPagamento || 0,
                valorReservado: contaAPagar?.valorReservado || 0,
                valorParaPagar: contaAPagar?.valorParaPagar || 0,
                valorPago: contaAPagar?.valorPago || 0,
                valorParaVincular: contaAPagar?.valorParaVincular || 0,
                valorVinculado: contaAPagar?.valorVinculado || 0,
                liberadorNome: contaAPagar?.liberador?.nome || "",
                aprovadorNome: contaAPagar?.aprovador?.nome || "",
                reprovadorNome: contaAPagar?.reprovador?.nome || "",
                reprovadorJustificativa: contaAPagar?.reprovadorJustificativa || "",
                pagamentos: pagamentos || [],
            }

        });

        return {
            id: dado?.id || "",
            index: index ?? null,
            tipo: dado?.tipo || "",
            sigla: dado?.sigla || "",
            codigo: dado?.codigo || "",
            status: dado?.status || "",
            credorNome: dado?.credor?.nome || "",
            credorTipo: dado?.credor?.tipo || "",
            valorOriginal: dado?.valorOriginal || 0,
            valorParaReservar: dado?.valorParaReservar || 0,
            valorDesconto: dado?.valorDesconto || 0,
            valorPagamento: dado?.valorPagamento || 0,
            valorReservado: dado?.valorReservado || 0,
            valorParaPagar: dado?.valorParaPagar || 0,
            valorPago: dado?.valorPago || 0,
            valorParaVincular: dado?.valorParaVincular || 0,
            valorVinculado: dado?.valorVinculado || 0,
            contasAPagarQuantidade: dado?.contasAPagarQuantidade || 0,
            pagamentosQuantidade: dado?.pagamentosQuantidade || 0,
            contasAPagar: contasAPagar || [],
        };

    });

    alteraDados(dadosPreparados);

};

//==================================================================//
//======================= Prepara Cartao ===========================//
//==================================================================//

const preparaCartao = ()=>{

    preparaDados(UtilArray.clone(dadosOriginais.value));

}

//==================================================================//
//======================== Permite Liberar ==========================//
//==================================================================//

const permiteLiberar = (dado = {}) => {

    return dado?.contasAPagar?.some((contaAPagar)=>{

        return contaAPagar?.status == "Prevista"

    });

};

//==================================================================//
//======================== Permite Aprovar ==========================//
//==================================================================//

const permiteAprovar = (dado = {}) => {

    return dado?.contasAPagar?.some((contaAPagar)=>{

        return  contaAPagar?.status == "Aguardando Aprovação"
    });

};

//==================================================================//
//=================== Permite Gerar Pagamentos =======================//
//==================================================================//

const permiteGerarPagamento = (dado = {}) => {

    return dado?.contasAPagar?.some((contaAPagar)=>{

        return  contaAPagar?.status == "Liberada" &&
                contaAPagar?.valorParaReservar > 0;

    });

};

//==================================================================//
//========================= Permite Baixar ==========================//
//==================================================================//

const permiteBaixar = (dado = {}) => {

    return dado?.contasAPagar?.some((contaAPagar)=>{

        if(
            contaAPagar?.status != "Liberada" ||
            contaAPagar?.forma != "Boleto" ||
            contaAPagar?.pagamentosQuantidade <= 0
        ){
            return false;
        }

        return contaAPagar?.pagamentos?.some((pagamento)=>{

            return pagamento?.status == "Pagamento não realizado";

        });

    });

};

//==================================================================//
//===================== DADO ORIGINAL POR ID ==========================//
//==================================================================//

const dadoOriginalPor = (dado = {}) => {

    return dadosOriginais.value?.[dado?.index] ?? {};

};

//==================================================================//
//======================== Ao Visualizar Dado ======================//
//==================================================================//

const aoVisualizarDado = (dado = {}) => {

    alteraVisualizandoDado({ dadoOriginal: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//========================== Ao Liberar Dado =======================//
//==================================================================//

const aoLiberarDado = (dado = {}) => {

    alteraLiberandoDado({ dadoOriginal: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//========================== Ao Aprovar Dado =======================//
//==================================================================//

const aoAprovarDado = (dado = {}) => {

    alteraAprovandoDado({ dadoOriginal: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//====================== Ao Gerar Pagamentos =======================//
//==================================================================//

const aoGerarPagamentos = (dado = {}) => {

    alteraGerandoPagamentos({ dadoOriginal: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//========================== Ao Baixar Dado =========================//
//==================================================================//

const aoBaixarDado = (dado = {}) => {

    alteraBaixandoDado({ dadoOriginal: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//================= Carrega Dados Pela Primeira Vez ================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async () =>{

    await loadListaDeDados();

});

//====================================================================//
//=== Prepara Cartao se Dados Originais Carregados ou Recarregados ===//
//=================== Watch => loadedDadosOriginais ==================//
//====================================================================//

watch(loadedDadosOriginais, () => {

    if(loadedDadosOriginais.value == true){
        preparaCartao();
    }

});

//==================================================================//
//=================== Recarrega Dados Originais ====================//
//=================== Watch => visualizandoDado ====================//
//==================================================================//

watch(visualizandoDado, () => {

    if(visualizandoDado.value == false){
        loadDadosOriginais();
    }

});

//==================================================================//
//=================== Recarrega Dados Originais ====================//
//==================== Watch => liberandoDado ======================//
//==================================================================//

watch(liberandoDado, () => {

    if(liberandoDado.value == false){
        loadDadosOriginais();
    }

});

//==================================================================//
//=================== Recarrega Dados Originais ====================//
//===================== Watch => aprovandoDado ======================//
//==================================================================//

watch(aprovandoDado, () => {

    if(aprovandoDado.value == false){
        loadDadosOriginais();
    }

});

//==================================================================//
//=================== Recarrega Dados Originais ====================//
//=================== Watch => gerandoPagamentos ====================//
//==================================================================//

watch(gerandoPagamentos, () => {

    if(gerandoPagamentos.value == false){
        loadDadosOriginais();
    }

});

//==================================================================//
//=================== Recarrega Dados Originais ====================//
//===================== Watch => baixandoDado ======================//
//==================================================================//

watch(baixandoDado, () => {

    if(baixandoDado.value == false){
        loadDadosOriginais();
    }

});

</script>

<template>

    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <TelaTabela
            :disabled="loadingListaDeDados"
            :filtros="filtros"
            :headers="dadosHeaders"
            :dados="dadosFiltrados"
            paginacao="paginada"
        >

            <template #tela-titulo>

                Contas a Pagar

            </template>

            <template #tabela-linha-item.codigo="{ dado }">

                <strong>{{ dado?.sigla }}</strong>: {{ dado?.codigo }}

            </template>

            <template #tabela-linha-item.credorNome="{ dado }">

                <span><strong>{{ dado?.credorTipo }}</strong><br>{{ dado?.credorNome }}</span>

            </template>

            <template #tabela-linha-item.contasAPagarQuantidade="{ dado }">

                <v-chip
                    color="indigo"
                    label
                    dark
                >

                    <v-icon left>
                        mdi-receipt-text
                    </v-icon>
                    {{ dado?.contasAPagarQuantidade }}

                </v-chip>

            </template>

            <template #tabela-linha-item.pagamentosQuantidade="{ dado }">

                <v-chip
                    color="primary"
                    label
                    dark
                >

                    <v-icon left>
                        mdi-cash-multiple
                    </v-icon>
                    {{ dado?.pagamentosQuantidade }}

                </v-chip>

            </template>

            <template #tabela-linha-botoes="{ dado, disabled }">

                <BotaoIconeBase
                    icon="mdi-eye"
                    color="#32434D"
                    text="Visualizar"
                    :disabled="disabled"
                    :click="() => aoVisualizarDado(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permiteLiberar(dado)"
                    icon="mdi-check-circle-outline"
                    color="#3E737B"
                    text="Liberar Contas a Pagar"
                    :disabled="disabled"
                    :click="() => aoLiberarDado(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permiteAprovar(dado)"
                    icon="mdi-gavel"
                    color="#4F6563"
                    text="Aprovar Contas a Pagar"
                    :disabled="disabled"
                    :click="() => aoAprovarDado(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permiteGerarPagamento(dado)"
                    icon="mdi-cash-plus"
                    color="#929B80"
                    text="Gerar Pagamentos"
                    :disabled="disabled"
                    :click="() => aoGerarPagamentos(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permiteBaixar(dado)"
                    icon="mdi-receipt-text-arrow-right"
                    color="#4F5951"
                    text="Baixar Contas a Pagar"
                    :disabled="disabled"
                    :click="() => aoBaixarDado(dado)"
                ></BotaoIconeBase>

            </template>

            <template #modais>

                <VisualizarDadosModal
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :visualizandoDado="visualizandoDado"
                    :dadoOriginal="dadoOriginal"
                    @update:alteraVisualizandoDado="alteraVisualizandoDado"
                ></VisualizarDadosModal>

                <LiberarDadosModal
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :controlesDesativados="controlesDesativados"
                    :liberandoDado="liberandoDado"
                    :dadoOriginal="dadoOriginal"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraLiberandoDado="alteraLiberandoDado"
                ></LiberarDadosModal>

                <AprovarDadosModal
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :controlesDesativados="controlesDesativados"
                    :aprovandoDado="aprovandoDado"
                    :dadoOriginal="dadoOriginal"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraAprovandoDado="alteraAprovandoDado"
                ></AprovarDadosModal>

                <GerarPagamentosModal
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :controlesDesativados="controlesDesativados"
                    :gerandoPagamentos="gerandoPagamentos"
                    :dadoOriginal="dadoOriginal"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraGerandoPagamentos="alteraGerandoPagamentos"
                ></GerarPagamentosModal>

                <BaixarDadosModal
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :controlesDesativados="controlesDesativados"
                    :baixandoDado="baixandoDado"
                    :dadoOriginal="dadoOriginal"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraBaixandoDado="alteraBaixandoDado"
                ></BaixarDadosModal>

            </template>

        </TelaTabela>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none;
}

</style>
